import { render, staticRenderFns } from "./DocumentosLeilao.vue?vue&type=template&id=73aef38a&scoped=true"
import script from "./DocumentosLeilao.vue?vue&type=script&lang=js"
export * from "./DocumentosLeilao.vue?vue&type=script&lang=js"
import style0 from "./DocumentosLeilao.vue?vue&type=style&index=0&id=73aef38a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aef38a",
  null
  
)

export default component.exports